import { useEffect, useState } from 'react';
// material
import { Button, Container } from '@material-ui/core';
import { Icon } from '@iconify/react';
import backFill from '@iconify/icons-eva/arrow-back-fill';
// eslint-disable-next-line import/no-unresolved
import CreateHeaderForm from 'src/components/_dashboard/headers/CreateHeaderForm';
// eslint-disable-next-line import/no-unresolved
// eslint-disable-next-line import/no-unresolved
import HeaderList from 'src/components/_dashboard/headers/HeaderList';
// redux
import { useDispatch, useSelector } from '../../redux/store';
import { getHeaderList } from '../../redux/slices/header';
import { getCategoryListByProject, resetCategoryListByProject } from '../../redux/slices/filecategory';
import { getClientList, getProjectListByClient, resetProjectListByClient } from '../../redux/slices/client';
// routes
import { PATH_DASHBOARD } from '../../routes/paths';
// hooks
import useSettings from '../../hooks/useSettings';
// components
import Page from '../../components/Page';
import HeaderBreadcrumbs from '../../components/HeaderBreadcrumbs';

// ----------------------------------------------------------------------

export default function Header() {
  const { themeStretch } = useSettings();
  const dispatch = useDispatch();
  const { headerList, disableHeaderList, isLoading } = useSelector((state) => state.header);
  const [headerListStatus, setHeaderListStatus] = useState(true);
  const [editId, setEditId] = useState('');
  const [deleteId, setDeleteId] = useState('');
  const [visibleComponent, setVisibleComponent] = useState('List');
  const [currentHeader, setCurrentHeader] = useState({});

  useEffect(() => {
    dispatch(getHeaderList(true));
    dispatch(getHeaderList(false));
    dispatch(getClientList(true));
    dispatch(resetProjectListByClient());
    dispatch(resetCategoryListByProject());
  }, [dispatch]);

  useEffect(() => {
    dispatch(getHeaderList(headerListStatus));
  }, [headerListStatus]);

  useEffect(() => {
    setVisibleComponent('List');
  }, []);

  useEffect(() => {
    if (editId) {
      setVisibleComponent('Edit');
      const tempHeader = headerList.find((header) => header.id === editId);
      const clientid = tempHeader.clients.map((a) => a.id);
      const projectId = tempHeader.projects.map((a) => a.id);
      dispatch(getProjectListByClient(clientid));
      dispatch(getCategoryListByProject(projectId));
      setCurrentHeader(tempHeader);
    } else setVisibleComponent('List');
  }, [editId]);

  useEffect(() => {
    if (visibleComponent !== 'Edit') setEditId('');
  }, [visibleComponent]);

  const setComponentList = (e) => {
    setVisibleComponent('List');
    e.preventDefault();
  };

  return (
    <Page title="Header | Smart Collect">
      <Container maxWidth={themeStretch ? false : 'lg'} style={{ paddingLeft: '10px', paddingRight: '10px' }}>
        <HeaderBreadcrumbs
          heading="Header"
          links={[
            { name: 'Dashboard', href: PATH_DASHBOARD.root },
            {
              name: 'Header',
              href: PATH_DASHBOARD.general.header,
              handleClick: (e) => {
                setComponentList(e);
              }
            },
            { name: `${visibleComponent} Header` }
          ]}
          action={
            visibleComponent === 'List' ? (
              <Button
                variant="contained"
                onClick={() => {
                  setVisibleComponent('Create');
                }}
              >
                Add Header
              </Button>
            ) : (
              <Button
                variant="contained"
                onClick={() => {
                  setVisibleComponent('List');
                }}
                startIcon={<Icon icon={backFill} />}
              >
                List
              </Button>
            )
          }
        />

        {visibleComponent === 'Create' && <CreateHeaderForm setVisibleComponent={setVisibleComponent} />}
        {visibleComponent === 'List' && (
          <HeaderList
            headerListStatus={headerListStatus}
            setHeaderListStatus={setHeaderListStatus}
            headerList={headerListStatus ? headerList : disableHeaderList}
            setEditId={setEditId}
            deleteId={deleteId}
            setDeleteId={setDeleteId}
            loading={isLoading}
          />
        )}
        {visibleComponent === 'Edit' && (
          <CreateHeaderForm setVisibleComponent={setVisibleComponent} currentHeader={currentHeader} editId={editId} />
        )}
      </Container>
    </Page>
  );
}
